export default __webpack_public_path__ + "assets/3d1c9c.gif";